enum DELIVERY_TYPE {
    PICKUP = 'pickup',
    DELIVERY = 'delivery'
}

export {
    DELIVERY_TYPE
}
